'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef } from 'react';
import { InternalProvider, useId, useCombinedRefs } from '../../util';
import { TextareaInput, TextareaLabel, TextareaContainer, HelperTextWrapper, CharCount } from './elements';
export const Textarea = /*#__PURE__*/React.forwardRef(({
  label,
  id: incomingId,
  name = '',
  value = '',
  disabled,
  helperText = '',
  className,
  containerClassName = '',
  inputClassName = '',
  labelClassName = '',
  helperTextClassName = '',
  fieldStatus = 'default',
  maxCharCount,
  rows,
  onChange,
  resize = true,
  ...restProps
}, fRef) => {
  const id = useId('text-field', incomingId);
  const innerRef = useRef();
  const combinedRef = useCombinedRefs(fRef, innerRef);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(TextareaContainer, {
    "data-aui": "textarea",
    id: `${id}-field-container`,
    $fieldStatus: fieldStatus,
    $disabled: disabled,
    className: containerClassName,
    onClick: () => {
      var _innerRef$current;
      return innerRef === null || innerRef === void 0 || (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.focus();
    }
  }, /*#__PURE__*/React.createElement(TextareaLabel, {
    htmlFor: id,
    className: labelClassName,
    $hasContent: !!value,
    $fieldStatus: fieldStatus
  }, label), /*#__PURE__*/React.createElement(TextareaInput, _extends({
    "aria-label": label,
    "aria-describedby": helperText && `${id}-text-area-helper-text`,
    placeholder: " ",
    id: id,
    ref: combinedRef,
    name: name,
    className: inputClassName,
    disabled: disabled,
    value: value
  }, restProps, {
    maxLength: maxCharCount,
    resize: resize,
    rows: rows,
    onChange: onChange
  }))), (helperText || maxCharCount) && /*#__PURE__*/React.createElement(HelperTextWrapper, {
    $fieldStatus: fieldStatus
  }, helperText && /*#__PURE__*/React.createElement("div", {
    className: helperTextClassName,
    "data-testid": "helper-text",
    id: `${id}-text-area-helper-text`
  }, helperText), !!maxCharCount && /*#__PURE__*/React.createElement(CharCount, {
    $textHelperPresent: !!helperText
  }, value.length, "/", maxCharCount))));
});